import type { ReactNode } from 'react';
import { EmployeeLink } from 'domain/shared/employee';
import { EmployeeLinkWithNameLoading } from 'domain/shared/employee';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';

export type TimelineRecordAuthorProps = {
  name?: string;
  id?: string | null;
  isOpenInNewTab?: boolean;
  isLink?: boolean;
  sx?: SxProps<Theme>;
};

const TimelineRecordAuthor = ({ name, id, isOpenInNewTab, isLink, sx }: TimelineRecordAuthorProps) => {
  let author: ReactNode;

  if (name) {
    author = <EmployeeLink id={id} name={name} isOpenInNewTab={isOpenInNewTab} isLink={isLink} />;
  } else if (id && id !== 'system') {
    author = (
      <Box sx={{ display: 'inline-flex', '.input-loader': { transform: 'translateY(3px)', marginTop: '-2px' } }}>
        <EmployeeLinkWithNameLoading
          id={id}
          defaultValue={DEFAULT_ENTITY_AUTHOR}
          isOpenInNewTab={isOpenInNewTab}
          isLink={isLink}
        />
      </Box>
    );
  } else {
    author = <span>{DEFAULT_ENTITY_AUTHOR}</span>;
  }

  return sx ? <Box sx={sx}>{author}</Box> : author;
};

export default TimelineRecordAuthor;
